import { B2Card, B2Col, B2Row } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  getLastSixMonthsFaultTurnAroundTimeByTC,
  getTurnAroundTimeLastMonth,
} from "src/core/api/services/dashboard.services";
import getLastMonthName from "src/shared/helpers/last-month";
import DashboardTrandingChart from "../custom-trending-chart/DashboardTrandingChart";
import TurnAroundTimeStatistics from "./TurnAroundTimeStatistics";
import "./turnAroundTime.scss";

const TurnAroundTime = () => {
  const [turnAroundTimeGraph, setTurnAroundTimeGraph] = useState<any>({
    xAxisData: [],
    seriesData: [],
  });

  const selectedTcCode = useSelector(
    (state: any) => state.dashboard.selectedTcCode
  );

  const {
    data: turnAroundTimeGraphData,
    isLoading: isLoadingturnAroundTimeGraphData,
  } = useQuery({
    queryKey: ["getLastSixMonthsFaultTurnAroundTimeByTC", selectedTcCode],
    queryFn: ({ signal }) =>
      getLastSixMonthsFaultTurnAroundTimeByTC(selectedTcCode, signal),
    enabled: !!selectedTcCode,
  });

  useEffect(() => {
    if (turnAroundTimeGraphData?.length > 0) {
      const xData = turnAroundTimeGraphData?.map((d: any) => d?.faultMonth);
      const series = turnAroundTimeGraphData?.map((d: any) => d?.avgHours);

      setTurnAroundTimeGraph({
        xAxisData: xData,
        seriesData: series,
      });
    }
  }, [turnAroundTimeGraphData]);

  const {
    data: turnAroundTimeLastMonth,
    isLoading: isLoadingTurnAroundTimeLastMonth,
  } = useQuery({
    queryKey: ["getTurnAroundTimeLastMonth", selectedTcCode],
    queryFn: ({ signal }) => getTurnAroundTimeLastMonth(selectedTcCode, signal),
    enabled: !!selectedTcCode,
  });

  return (
    <B2Col xs={12} lg={6} className="mb-3 mb-lg-0 px-lg-2">
      <B2Card className="p-3">
        <B2Row className="d-flex">
          <h4 className="fw-bold mb-3 text-center d-block d-sm-none">
            Turn Around Time{" "}
            <span style={{ fontSize: "14px", color: "#495057" }}>
              ({getLastMonthName()})
            </span>
          </h4>

          <B2Col xs={12} md={6} className="mb-1 mb-sm-0">
            <h4 className="fw-bold textNeutral600 d-none d-sm-block mb-4">
              Turn Around Time{" "}
              <span style={{ fontSize: "14px", color: "#495057" }}>
                ({getLastMonthName()})
              </span>
            </h4>
            <div className="d-flex justify-content-between align-items-center turnAroundTimeStats">
              <TurnAroundTimeStatistics
                count={turnAroundTimeLastMonth?.maxHours || 0}
                isLoading={isLoadingTurnAroundTimeLastMonth}
                name="Highest"
              />
              <TurnAroundTimeStatistics
                count={turnAroundTimeLastMonth?.avgHours || 0}
                isLoading={isLoadingTurnAroundTimeLastMonth}
                name="Average"
              />
              <TurnAroundTimeStatistics
                count={turnAroundTimeLastMonth?.minHours || 0}
                isLoading={isLoadingTurnAroundTimeLastMonth}
                name="Lowest"
              />
            </div>
          </B2Col>
          <B2Col xs={12} md={6} className="mt-sm-3">
            {isLoadingturnAroundTimeGraphData ? (
              <div className="d-flex justify-content-center">
                <Spinner animation="grow" variant="primary" />
              </div>
            ) : (
              <DashboardTrandingChart
                xAxisCategory={turnAroundTimeGraph?.xAxisData}
                seriesData={turnAroundTimeGraph?.seriesData}
                xToolTip="Month"
                yToolTip="Avg. Turn Around Time"
                hr={"hour"}
              />
            )}
          </B2Col>
        </B2Row>
      </B2Card>
    </B2Col>
  );
};

export default TurnAroundTime;
